module.exports = __webpack_public_path__ + "static/img/KY.57ed8eaa.svg";